import { computed } from 'vue';
import { capitalizeWord } from '~/utils/StringsUtil';
import { useEnvPropsStore } from '~/stores/envProps';
import { useHeaderBannerStore } from '~/stores/headerBanner';
import { useGiftGiverRegistryView } from '~/stores/giftGiverRegistryView';
import addOrUpdateItemToBag from '@nuxt-common/add-to-bag/app/composables/useAddToBag';

export default function useAddToBag() {
  const envPropsStore = useEnvPropsStore();
  const headerBannerStore = useHeaderBannerStore();
  const giftGiverRegistryViewStore = useGiftGiverRegistryView();

  const isBcom = computed(() => envPropsStore.envProps.entryPoint.toUpperCase() === 'BCOM');
  const headerBanner = computed(() => headerBannerStore.headerBanner);
  const giftGiver = computed(() => giftGiverRegistryViewStore.registryInfo);

  const addToBagEventHeaderLinkText = computed(() => {
    if (headerBanner.value?.registrants) {
      const registrant = headerBanner.value?.registrants.find((person) => person.role === 'Registrant');
      const coregistrant = headerBanner.value?.registrants.find((person) => person.role === 'Partner');
      const registrantFirstName = capitalizeWord(registrant?.firstName);
      const registrantLastName = capitalizeWord(registrant?.lastName);
      if (coregistrant?.firstName && coregistrant?.lastName) {
        const coregistrantFirstName = capitalizeWord(coregistrant?.firstName);
        const coregistrantLastName = capitalizeWord(coregistrant?.lastName);
        return `${registrantFirstName} ${registrantLastName} & ${coregistrantFirstName} ${coregistrantLastName}`;
      }
      return `${registrantFirstName} ${registrantLastName}`;
    }
    if (giftGiver.value?.eventTitle) {
      return giftGiver.value.eventTitle;
    }
    return '';
  });

  const addToBagEventHeaderDirectLinkText = computed(() => {
    const occasion = headerBanner.value?.occasionType || giftGiver.value?.occasionType;
    if (occasion && isBcom.value) {
      return `${addToBagEventHeaderLinkText.value}’s ${occasion} Registry`;
    }
    return addToBagEventHeaderLinkText.value;
  });

  const addItemToBag = (payload, options) => {
    const defaultOptions = {};
    if (options?.useDirectLink) {
      defaultOptions.registrants = addToBagEventHeaderDirectLinkText.value;
    } else {
      defaultOptions.registrants = addToBagEventHeaderLinkText.value;
    }

    const finalOptions = { ...defaultOptions, ...options };
    return addOrUpdateItemToBag(payload, finalOptions);
  };

  return {
    addToBagEventHeaderLinkText,
    isBcom,
    headerBanner,
    giftGiver,
    addToBagEventHeaderDirectLinkText,
    addItemToBag,
  };
}
